// extracted by mini-css-extract-plugin
export var title = "BlogSidebar-module--title--jYz6q";
export var blog_sidebar = "BlogSidebar-module--blog_sidebar--ORKRy";
export var blog_sidebar_section = "BlogSidebar-module--blog_sidebar_section--+GCJs";
export var author_photo = "BlogSidebar-module--author_photo--aTobc";
export var author_name = "BlogSidebar-module--author_name--DxH1t";
export var author_info = "BlogSidebar-module--author_info--TGqDL";
export var social_links = "BlogSidebar-module--social_links--9VR4H";